import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  selector: 'email-requisitions-approval-request-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './requisitions-approval-request.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class RequisitionsApprovalRequestTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<RequisitionsApprovalRequestTemplateData>;
}

export type RequisitionsApprovalRequestTemplateData = {
  title: string;
  p1: string;
  p2: string;
  button_link: string;
  button_text: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const RequisitionsApprovalRequestTemplateMocks: RequisitionsApprovalRequestTemplateData[] = [
  {
    title: 'Approval requested',
    p1: '<b>Roche Foose</b> sent you an approval request for <b>Product Designer</b> requisition',
    p2: 'Take your time to review the requisition - you can approve it or reject it.',
    button_link: 'http://recruitee.com',
    button_text: 'Go to requisitions',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
